import React from "react";
import Main from "../components/Main/Main";

function HomePage() {
  return (
    <div>
      <Main />
    </div>
  );
}

export default HomePage;
